import React from 'react';
import { css as reactCss } from '@emotion/react';

import { bundledConfig } from '~src/config/bundled-config';
import { colors } from '~src/main/theme/colors';

export const Footer: React.FC = () => {
  return (
    <div css={styles.wrapper} aria-label="Footer">
      <img alt="Ingrid" height="14" src={`${bundledConfig.cdnUrl}/static/footer/ingrid-logo.svg`} />
    </div>
  );
};

const styles = {
  wrapper: reactCss({
    borderTop: `1px solid ${colors.neutral90}`,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '12px 0 18px',
  }),
};
